/* @flow */
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import Icon from '../Icon';
import FlexBox from '../FlexBox';
import withI18n from '../../utils/withI18n';
import feature from '../../config/feature';
import zIndexScale from '../../utils/zIndexScale';
import urlConfig from '../../config/urls';
import VipLevel from '../UserInfo/VipLevel';
import UserFees from '../UserInfo/UserFees';
import BnbBurningStatus from '../UserInfo/BnbBurningStatus';
import FeeDiscount from '../UserInfo/FeeDiscount';
import { track, sensorEventTypes } from '../../utils/sensors';

const { VIEW_TRADE_FEE_DETAIL } = sensorEventTypes;

const GOLINK = '>>';

const {
  user: { index: USERCENTER },
} = urlConfig;

const { enableBnbPayment } = feature;

const Link = styled.a`
  margin-right: 5px;
  color: ${({ theme }) => theme.highlight};
  :visited,
  :hover {
    color: ${({ theme }) => theme.highlight};
  }
`;

const FeeCalculator = styled(FlexBox)`
  position: relative;
  cursor: pointer;
  padding-top: 5px;
  margin-top: -5px;
  a {
    color: ${({ theme }) => theme.highlight};
  }
`;

const CalculatorBox = styled.div`
  position: absolute;
  right: 0;
  bottom: 25px;
  z-index: ${zIndexScale.tooltip};
  width: ${({ commissionStatus }) => (commissionStatus === 1 ? '390px' : '290px')};
  color: ${({ theme }) => theme.fontColor};
  background: ${({ theme }) => theme.tooltipBg};
  font-size: 12px;
  padding: 15px 15px 0;
  box-shadow: ${({ theme }) => theme.toolTipBoxShadow};
  white-space: nowrap;
  cursor: default;
`;
const CaculatorBoxHeader = styled(FlexBox)`
  line-height: 100%;
  margin-bottom: 12px;
  & > span {
    font-size: 14px;
    color: ${({ theme }) => theme.fontColor};
    margin-right: 4px;
  }
`;

const CaculatorBoxFooter = styled(FlexBox)`
  border-top: 1px solid ${({ theme }) => theme.border};
  line-height: 100%;
  padding: 10px 0 12px;
  margin-top: 10px;
`;

const mapStateToProps = ({
  isLoggedIn,
  userInfo,
  userAssets,
  locale,
  userGasRate,
  userTradeFee,
}) => ({
  isLoggedIn,
  userInfo,
  userAssets,
  locale,
  userGasRate,
  userTradeFee,
});

type userInfoType = {
  userData: {
    commissionStatus: number,
  },
  tradeLevel: number,
};

type userAssetsType = {
  BNB: number,
};

type ComponentProps = {
  isLoggedIn: boolean,
  userInfo: userInfoType,
  userAssets: userAssetsType,
  locale: string,
  i18n: Object,
  userGasRate: number,
  userTradeFee: Object,
};

type stateType = { shouldShowCalculator: boolean };

export default
@connect(mapStateToProps)
@withI18n
class Fee extends Component<ComponentProps, stateType> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
    isLoggedIn: false,
    userInfo: {
      userData: { commissionStatus: 0 },
      tradeLevel: 0,
    },
    userAssets: { BNB: 0 },
    userGasRate: 0,
    userTradeFee: {},
  };

  state = {
    shouldShowCalculator: false,
  };

  _shouldShowCalculator = () => {
    this.setState({
      shouldShowCalculator: true,
    });
    const { userInfo } = this.props;
    track(VIEW_TRADE_FEE_DETAIL, { vipLevel: userInfo.tradeLevel });
  };

  _hideCaculator = () => {
    this.setState({
      shouldShowCalculator: false,
    });
  };

  _renderCaculatorBox = () => {
    const {
      i18n, locale, userInfo, userAssets, userGasRate, userTradeFee,
    } = this.props;
    const { commissionStatus } = userInfo.userData || {};
    const feeScheduleLink = `/${locale}/fee/schedule`;
    const userCenterLink = USERCENTER.replace('%locale', locale);
    return (
      <CalculatorBox commissionStatus={commissionStatus}>
        <CaculatorBoxHeader align="center">
          <span>{i18n['Your level'] || 'Your level'}:</span>
          <VipLevel i18n={i18n} userInfo={userInfo} onlyShowLevel={false} />
          &nbsp;&nbsp;
          <Link href={feeScheduleLink}>
            <a id="OrderForms-fee-a-Details">{i18n.Details || 'Details'} {GOLINK}{' '}</a>
          </Link>
        </CaculatorBoxHeader>
        <FlexBox align="center">
          <span>
            {commissionStatus === 0
              ? i18n.BNBpaymentNotOpen || 'Not using BNB for fees'
              : i18n.BNBpayment || 'Using BNB for fees'}
          </span>
          <FeeDiscount
            i18n={i18n}
            userInfo={userInfo}
            userAssets={userAssets}
            userGasRate={userGasRate}
          />
          &nbsp;&nbsp;
          {commissionStatus !== 1 && (
            <Link href={userCenterLink}>
              {i18n.closeIt} {GOLINK}{' '}
            </Link>
          )}
        </FlexBox>
        <CaculatorBoxFooter>
          <UserFees
            i18n={i18n}
            userInfo={userInfo}
            userTradeFee={userTradeFee}
            userGasRate={userGasRate}
            isDiscount={true}
          />
        </CaculatorBoxFooter>
      </CalculatorBox>
    );
  };

  render() {
    const {
      isLoggedIn,
      i18n,
      userInfo,
      userAssets,
      locale,
      // userTradeFee,
      // userGasRate,
    } = this.props;
    const { shouldShowCalculator } = this.state;
    // const feeScheduleLink = `/${locale}/fee/schedule`;
    if (isLoggedIn) {
      return (
        <FlexBox justify="space-between" align="center">
          {enableBnbPayment ? (
            <BnbBurningStatus
              i18n={i18n}
              locale={locale}
              userInfo={userInfo}
              userAssets={userAssets}
            />
          ) : null}
          {/* <Link href={feeScheduleLink}>
            <VipLevel i18n={i18n} userInfo={userInfo} onlyShowLevel={true} />
          </Link> */}
          &nbsp;
          {/* <UserFees
            i18n={i18n}
            userInfo={userInfo}
            userTradeFee={userTradeFee}
            userGasRate={userGasRate}
            isDiscount={false}
            delimiter="/"
          /> */}
          <FeeCalculator
            onMouseEnter={this._shouldShowCalculator}
            onMouseLeave={this._hideCaculator}
          >
            <Icon type="calculator" size={16} color="#666" />
            {shouldShowCalculator ? this._renderCaculatorBox() : null}
          </FeeCalculator>
        </FlexBox>
      );
    }
    return null;
  }
}
